// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SmileTwoToneSvg from "@ant-design/icons-svg/es/asn/SmileTwoTone";
import AntdIcon from '../components/AntdIcon';

var SmileTwoTone = function SmileTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SmileTwoToneSvg
  }));
};

SmileTwoTone.displayName = 'SmileTwoTone';
export default React.forwardRef(SmileTwoTone);